import { Component, inject, OnInit } from '@angular/core';
import pkg from '../../package.json';
import { BrokerDetail, BrokerStylingService } from './services/broker-styling.service';
import { ConnectionMonitorService } from './services/connection-monitor.service';
import { GclidService } from './services/gclid.service';
import { GaCookieService } from './services/ga-cookie.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{
  private brokerStylingService = inject(BrokerStylingService)
  private connectionMonitor = inject(ConnectionMonitorService)
  private gclidService = inject(GclidService)
  private gaService = inject(GaCookieService)

  title = 'DEV - HFQ';
  broker!: BrokerDetail

  ngOnInit(): void {
    console.warn(`Version: ${pkg.version}`)

    console.log(`Glid = ${this.gclidService.getGclid()}`)
    console.log(`GaCookie = ${this.gaService.getClientId()}`)
    
    this.broker = this.brokerStylingService.getBrokerDetailFromDomain()

    if(this.broker.brokerId == '01'){
      this.brokerStylingService.applyChillStyle()
    }
    else if(this.broker.brokerId == '04'){
      this.brokerStylingService.applyQDStyle()
    }
  }
}
